import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   

    getWechatMenuIndex(state,value){

       
        post(urls.admin.wechat_menu.index,value).then((result)=>{
          
          
          
          state.result=result


        
       
        
       
           
        });
        
    },


    addWechatMenu(state,value){
        
        post(urls.admin.wechat_menu.add,value).then((result)=>{

          state.result=result

        });
        
    },
    editWechatMenu(state,value){

        post(urls.admin.wechat_menu.edit,value).then((result)=>{

            state.result=result

        });

    },
    deleteWechatMenu(state,value){

        post(urls.admin.wechat_menu.delete,value).then((result)=>{

            state.result=result

        });

    },
    createWechatMenu(state,value){

        post(urls.admin.wechat_menu.create,value).then((result)=>{

            state.result=result

        });

    },
    updateWechatMenu(state,value){

        post(urls.admin.wechat_menu.update,value).then((result)=>{

            state.result=result

        });

    },

    configWechat(state,value){

        post(urls.admin.wechat_menu.config,value).then((result)=>{

            state.result=result

        });

    },

    

}
const  actions={


    getWechatMenuIndexAction(context,value){
       
        context.commit("getWechatMenuIndex",value)
       
    },
  
    addWechatMenuAction(context,value){
       
        context.commit("addWechatMenu",value)
       
    },
    editWechatMenuAction(context,value){

        context.commit("editWechatMenu",value)

    },
    deleteWechatMenuAction(context,value){

        context.commit("deleteWechatMenu",value)

    },
    createWechatMenuAction(context,value){

        context.commit("createWechatMenu",value)

    },
    updateWechatMenuAction(context,value){

        context.commit("updateWechatMenu",value)

    },
    configWechatAction(context,value){

        context.commit("configWechat",value)

    },

    
    

}

export default {state,mutations,actions}